import React from 'react';
import { Link } from 'react-router';
import './index.css';

const TextBtnContent = ({ text, icon }) => {
  return (
    <div className="TextBtn__content">
      <span className="TextBtn__btn_icon">{icon}</span>
      <span>{text}</span>
    </div>
  );
};

const TextBtnType = ({ children, linkTo, icon, onClick, href }) => {
  // react-router link
  if (linkTo) {
    return (
      <Link className="TextBtn__btn TextBtn__btn--link u__normalize_anchor" to={linkTo}>
        <TextBtnContent icon={icon} text={children} />
      </Link>
    );
  }

  // regular html anchor
  if (href) {
    return (
      <a href={href} className="TextBtn__btn TextBtn__btn--anchor u__normalize_anchor">
        <TextBtnContent icon={icon} text={children} />
      </a>
    );
  }

  // div with onClick callback
  if (onClick) {
    return (
      <div className="TextBtn__btn" onClick={onClick}>
        <TextBtnContent icon={icon} text={children} />
      </div>
    );
  }

  return (
    <div className="TextBtn__btn">
      <TextBtnContent text={children} />
    </div>
  );
};

const TextBtn = props => {
  return (
    <div className="TextBtn">
      <TextBtnType {...props} />
    </div>
  );
};

export default TextBtn;



// WEBPACK FOOTER //
// ../ui-components/components/TextBtn/index.jsx